const MIN_SHOW_TIME = 500;
const MIN_DELAY_HIDE_LOADER = 50;

export default class {
    private startLoaderTime: number = 0;
    private timerId: number|null|NodeJS.Timeout = null;
    private activeCount: number = 0;
    public loading: boolean = false;
    private queue: Date[] = [];

    private clearTimer() {
        if (this.timerId) {
            clearTimeout(<NodeJS.Timeout>this.timerId);
            this.timerId = null;
        }
    }

    public showLoader(): Date {
        this.activeCount += 1;
        this.clearTimer();
        this.loading = true;
        if (!this.startLoaderTime) {
            this.startLoaderTime = (new Date()).getTime();
        }
        const flag = new Date();
        this.queue.push(flag);
        return flag;
    }

    public hideLoader(flag: Date) {
        const findObject: Date|undefined = this.queue.find((dateItem) => dateItem === flag);
        if (findObject) {
            this.queue.splice(this.queue.indexOf(findObject), 1);

            this.activeCount -= 1;
            if (this.activeCount !== 0) return;

            this.clearTimer();
            const currentTime = (new Date()).getTime();
            const showTime = currentTime - this.startLoaderTime;
            this.timerId = setTimeout(() => {
                this.clearTimer();
                this.loading = false;
                this.startLoaderTime = 0;
            }, showTime < MIN_SHOW_TIME ? MIN_SHOW_TIME - showTime : MIN_DELAY_HIDE_LOADER);
        }
    }
}
